import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../../redux/features/modalSlice";

import { useUpdateSubCategoryMutation, } from "../../redux/services/subCategoriesService/subCategories.Services";

import { useGetCategoriesQuery, } from "../../redux/services/categoriesService/categories.Services";
import { errorToast, successToast } from "../../Utils/toast";

function EditSubCategory({ data }) {
  const dispatch = useDispatch();
  const [updateSubCategory, { isLoading }] = useUpdateSubCategoryMutation();
  const { data: categoryData } = useGetCategoriesQuery();
  const categories = categoryData?.data || [];
  const [formData, setFormData] = useState({
    name: data?.name || "",
    description: data?.description || "",
   status: data?.status,
    category_id: String(data?.category_id || ""),
    image: null
  });
  const [preview, setPreview] = useState(
    data?.image
      ? `${process.env.REACT_IMAGE_URL}/${data.image}`
      : null
  );
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async () => {
    try {
   const res=   await updateSubCategory({
        id: data?.id,
        data: formData,
      }).unwrap();

     if (res.success === 1) {

      successToast(res.message);

      dispatch(closeModal());

    }

    } catch (error) {

      console.log(error);

      errorToast(error?.data?.message ||"Update Failed");

    }

  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData({
        ...formData,
        image: file,
      });

      setPreview(URL.createObjectURL(file));
    }
  };
  return (
    <>
      <div className="custom-modal-body">

        <div className="model-custum">

          {/* NAME */}
          <div className="edit-form-group">

            <label>
              SubCategory Name
            </label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          {/* CATEGORY */}
          <div className="edit-form-group">

            <label>
              Category
            </label>

            <select
              name="category_id"
              value={formData.category_id}
              onChange={handleChange}
              className="form-control"
            >

              <option value="">
                Select Category
              </option>

              {
                categories.map((item) => (

                  <option
                    key={item.id}
                    value={String(item.id)}
                  >
                    {item.name}
                  </option>

                ))
              }

            </select>

          </div>

          {/* DESCRIPTION */}
          <div className="edit-form-group">

            <label>
              Description
            </label>

            <textarea
              rows="4"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="form-control"
            />

          </div>
          <div className="mb-3">

            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="form-control"
            >

              <option value="active">Active</option>

              <option value="inactive">Inactive</option>

            </select>

          </div>
          <div className="mb-3">
            <label>Image</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={handleImageChange}
            />

            {preview && (
              <img
                src={preview}
                alt="preview"
                width="100"
                style={{
                  marginTop: "10px",
                  borderRadius: "10px",
                }}
              />
            )}
          </div>
        </div>

      </div>

      {/* BUTTONS */}
      <div className="modal-btn-group">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleSubmit}
          disabled={isLoading}
        >

          {
            isLoading
              ? "Updating..."
              : "Save Changes"
          }

        </button>

      </div>
    </>
  );
}

export default EditSubCategory;